import { create } from '@thoughtspot/logger';
import { DispatchChartInteractionType, DispatchChartInteractionUseCase, } from '@thoughtspot/ts-chart-sdk';
import { handleDispatchEmbedEvent, handleTriggerOnParent, } from './trigger-event';
import { validateDispatchChartInteractionPayload } from './utils';
const logger = create('chart-to-ts > dispatch-chart-interaction');
export const getDispatchChartInteractionEventProcessor = (props) => {
    const { iFrameWindow, chartModel, onPointRightClick, onPointClick, onPointDoubleClick, } = props;
    const chartColumns = chartModel.columns.map(col => col.column);
    const validateEventPayload = (eventData) => {
        const payload = eventData.payload;
        try {
            validateDispatchChartInteractionPayload(payload);
        }
        catch (err) {
            logger.warn(err);
            return {
                isValid: false,
                errors: [err.toString()],
            };
        }
        return {
            isValid: true,
        };
    };
    return {
        validateEventPayload,
        executeEvent: async (eventData) => {
            const payload = eventData.payload;
            payload.useCases.forEach(useCase => {
                switch (useCase) {
                    case DispatchChartInteractionUseCase.TriggerOnParent:
                        if (payload.type ===
                            DispatchChartInteractionType.PointerDown) {
                            handleTriggerOnParent(payload.type, payload.eventPayload, iFrameWindow);
                        }
                        break;
                    case DispatchChartInteractionUseCase.DispatchEmbedEvent:
                        handleDispatchEmbedEvent(payload, chartColumns, {
                            onPointRightClick,
                            onPointClick,
                            onPointDoubleClick,
                        });
                        break;
                    default:
                        logger.warn(`Unknown DispatchChartInteraction useCase: ${useCase}`);
                }
            });
            return Promise.resolve();
        },
    };
};
//# sourceMappingURL=index.js.map